import {useEffect} from 'react';
import {useApi} from "./useApi";
import {setCookie, getCookie} from 'lib/utils/cookies';

const FillingEmailProvider = ({ children }) => {
    const {getGlobalState} = useApi()
    const globalState = getGlobalState()
    const cookieLogin = getCookie('SV_LOGIN')

    useEffect(() => {
        const cookieValue = getCookie('filling_email_popup_shown');
        const cookieEmailPopupShown = cookieValue ? JSON.parse(cookieValue) : false;

        if(cookieLogin && !cookieEmailPopupShown) {
            if(globalState?.userEmail.includes('@tempmail.com')) {
                setCookie('filling_email_popup_shown', true)
            }
        }
    }, [globalState?.userId]);

    useEffect(() => {
        const cookieValue = getCookie('filling_email_popup_shown');
        const cookieEmailPopupShown = cookieValue ? JSON.parse(cookieValue) : false;

        if (cookieEmailPopupShown) {
            setCookie('filling_email_popup_shown', false);
        }
    }, []);

    return <>{children}</>;
}

export default FillingEmailProvider;